module.exports = __webpack_public_path__ + "static/media/master_promotion_01.162677f4.gif";